<template>
    <div>
        <v-text-field
                v-model="formData.displayName"
                label="Name"
                :counter="30"
                required
                :error-messages="displayNameErrors"
                @input="$v.formData.displayName.$touch()"
                @blur="$v.formData.displayName.$touch()"
        ></v-text-field>
        <v-text-field
                v-model="formData.email"
                label="Email"
                required
                :error-messages="emailErrors"
                @input="$v.formData.email.$touch()"
                @blur="$v.formData.email.$touch()"
        ></v-text-field>
    </div>
</template>

<script>
  import {FieldsMixin} from '@/forms/mixins'
  import {email, required, minLength, maxLength} from 'vuelidate/lib/validators'

  export default {
    name: 'UserProfileFields',
    mixins: [FieldsMixin],
    data: () => ({
      formData: {
        displayName: null,
        email: null
      }
    }),
    validations: {
      formData: {
        displayName: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(30)
        },
        email: {
          required,
          email
        }
      }
    },
    computed: {
      displayNameErrors () {
        const errors = []
        if (!this.$v.formData.displayName.$dirty) return errors
        !this.$v.formData.displayName.required && errors.push('Name is required.')
        !this.$v.formData.displayName.minLength && errors.push('Name must be at least 3 character long')
        !this.$v.formData.displayName.maxLength && errors.push('Name must be at most 30 characters long')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.formData.email.$dirty) return errors
        !this.$v.formData.email.email && errors.push('Must be a valid email address')
        return errors
      }
    }
  }
</script>

<style scoped>

</style>
